export default __webpack_public_path__ + "media/zurb/img/lab/thumbnails/ux-metric-cheatsheet-thumb-3be281429533bc0533127fe5d511657b.png";